import axios from "axios";
import apiConfig from "../config/apiConfig";

const BASE_URL = apiConfig.BASE_URL;

function getStoredToken() {
  try {
    const persistRoot = localStorage.getItem("persist:root");
    if (persistRoot) {
      const parsed = JSON.parse(persistRoot);
      if (parsed.auth) {
        const authState = JSON.parse(parsed.auth);
        return authState.token;
      }
    }
  } catch (e) {
    console.warn("Could not read token from redux-persist:", e);
  }
  return (
    localStorage.getItem("storehub_token") ||
    sessionStorage.getItem("storehub_token")
  );
}

function getAuthHeaders() {
  const token = getStoredToken();
  if (!token || token === "null" || token === "undefined") {
    throw new Error("Authentication required. Please log in again.");
  }
  return { headers: { Authorization: `Bearer ${token}` } };
}

export const fetchWooCommerceProducts = async (storeId) => {
  const auth = getAuthHeaders();
  const response = await axios.get(
    `${BASE_URL}/api/integrations/woocommerce/${storeId}/products`,
    auth
  );
  const data = response.data;
  return Array.isArray(data?.products) ? data.products : (Array.isArray(data) ? data : []);
};

export const fetchShopifyProducts = async (storeId) => {
  const auth = getAuthHeaders();
  const response = await axios.get(
    `${BASE_URL}/api/integrations/shopify/${storeId}/products`,
    auth
  );
  const data = response.data;
  return Array.isArray(data?.products) ? data.products : (Array.isArray(data) ? data : []);
};

export const importProducts = async ({ storeId, source, products, externalProductIds }) => {
  const auth = getAuthHeaders();
  const payload = { storeId, source };
  if (Array.isArray(products) && products.length > 0) {
    payload.products = products;
  } else if (Array.isArray(externalProductIds) && externalProductIds.length > 0) {
    payload.externalProductIds = externalProductIds;
  }
  const response = await axios.post(
    `${BASE_URL}/api/integrations/products/import`,
    payload,
    auth
  );
  return response.data;
};

